module.exports = __webpack_public_path__ + "static/media/Salary45k.bad6ce16.png";